import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const Footer = styled.div<{
  hasReferrals: boolean;
  showPagination: boolean;
  showDisclaimers: boolean;
}>`
  // KENG-28970
  // Adding some extra margin to the footer when crm is enabled
  // and referral list drawer is open
  margin-bottom: ${(props) => () =>
    props.hasReferrals ? `300px;` : fromTheme('spacing_xxlarge')};

  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${fromTheme('spacing_xlarge')};
  grid-template-areas: ${({ showPagination, showDisclaimers }) => {
    let template = '';
    if (showPagination) {
      template += `'pagination'`;
    }
    template += `'suggestions'`;
    if (showDisclaimers) {
      template += `'disclaimer'`;
    }
    template += `'poweredby'`;
    return template;
  }};

  button {
    background: transparent;
  }

  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: ${({ showPagination, showDisclaimers }) => {
      let template = '';
      if (showPagination) {
        if (showDisclaimers) {
          template = `'pagination poweredby' 'suggestions suggestions' 'disclaimer disclaimer'`;
        } else {
          template = `'pagination poweredby' 'suggestions suggestions'`;
        }
      } else {
        if (showDisclaimers) {
          template = `'suggestions suggestions' 'disclaimer poweredby'`;
        } else {
          template = `'suggestions suggestions' 'poweredby poweredby'`;
        }
      }
      return template;
    }};
  }
`;
